module.exports = __webpack_public_path__ + "static/media/Naltrexone Initiation for Alcohol Use Disorder SLIDE 09-22_ FINAL.3ff01af6.pdf";